export default __webpack_public_path__ + "static/media/ico_add_patient.fd87b2a7.svg";